function hideChatwootBubble() {
  if (window.$chatwoot && typeof window.$chatwoot.toggleBubbleVisibility === 'function') {
    window.$chatwoot.toggleBubbleVisibility('hide');
  }

  // Fallback: reset() reloads the launcher DOM; hide any leftover nodes.
  document
    .querySelectorAll(
      '.woot-widget-bubble, .woot--bubble-holder, .woot-widget-holder, #cw-bubble-holder, .woot-widget-box'
    )
    .forEach((el) => {
      el.style.display = 'none';
    });
}

export default () => {
  if (!window.$chatwoot) return;

  try {
    if (typeof window.$chatwoot.toggle === 'function') {
      window.$chatwoot.toggle('close');
    }
  } catch (err) {
    console.error('Chatwoot close failed', err);
  }

  try {
    if (typeof window.$chatwoot.reset === 'function') {
      window.$chatwoot.reset();
    }
  } catch (err) {
    console.error('Chatwoot reset failed', err);
  }

  hideChatwootBubble();

  window.addEventListener('chatwoot:ready', hideChatwootBubble, { once: true });
  setTimeout(hideChatwootBubble, 300);
};
